import './index.css';
import App from './App';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { initilizePiwikPro } from './helpers';

initilizePiwikPro();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
